module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGad465eb1db4df41e085b8b25c44b203d.ad465eb1.png";